import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { green, grey } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const radioTokens = [
  { propertyPath: 'checkedBorderColor', tokenName: '--semantic-border-inverse' },
  { propertyPath: 'checkedColor', tokenName: '--bg-interactive-control-selected' },
  { propertyPath: 'checkedDisabledColor', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'checkedDisabledBorderColor', tokenName: '--semantic-border-disabled' },
  { propertyPath: 'checkedHoverColor', tokenName: '--bg-interactive-control-selected-hover' },
  { propertyPath: 'hoverBackgroundColor', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'uncheckedBorderColor', tokenName: '--semantic-border-bold' },
  // consolidate to just one disabled color between checked & unchecked
  // after feature flag is removed
  // sc-164282
  { propertyPath: 'uncheckedDisabledColor', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'disabledBorderColor', tokenName: '--semantic-border-default' },
  { propertyPath: 'uncheckedHoverBorderColor', tokenName: '--semantic-border-inverse' },
] satisfies Token[];

export const radioTokenMetadata: PaletteTokenMetadata = {
  componentName: 'radio',
  tokens: radioTokens,
};

export const radio = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['radio'] => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(radioTokenMetadata.tokens, semanticTokens, xcorTokens);
  }

  return mode === 'light'
    ? {
        checkedColor: green[600],
        checkedHoverColor: green[500],
        checkedBorderColor: grey[600],
        checkedDisabledColor: grey[300],
        checkedDisabledBorderColor: grey[300],
        uncheckedBorderColor: grey[600],
        uncheckedHoverBorderColor: grey[500],
        uncheckedDisabledColor: grey[300],
        disabledBorderColor: grey[300],
        hoverBackgroundColor: grey[50],
      }
    : {
        checkedColor: green[500],
        checkedHoverColor: green[400],
        checkedBorderColor: grey[200],
        checkedDisabledColor: grey[500],
        checkedDisabledBorderColor: grey[400],
        uncheckedBorderColor: grey[200],
        uncheckedHoverBorderColor: grey[300],
        uncheckedDisabledColor: grey[400],
        disabledBorderColor: grey[400],
        hoverBackgroundColor: grey[700],
      };
};
